
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/forgot-password",
      function () {
        return require("private-next-pages/_sites/[site]/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/forgot-password"])
      });
    }
  